<template>
  <div>
    <v-toolbar
      color="cyan"
      dark
      tabs
    >
      <v-toolbar-title>คำร้องนักศึกษา</v-toolbar-title>

      <template v-slot:extension>
        <v-tabs
          v-model="tab"
          centered
          color="cyan"
          slider-color="yellow"
        >
          <v-tab
            v-for="item in items"
            :key="item.key"
            :href="`#tab-${item.key}`"
          >
            {{ item.label }}
          </v-tab>
        </v-tabs>
      </template>
    </v-toolbar>

    <v-tabs-items v-model="tab">
      <v-tab-item
        v-for="item in items"
        :key="item.key"
        :value="`tab-${item.key}`"
      >
        <component :is="item.key" :form="form"><slot></slot></component>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import BasicInfo from './formBasic.vue'
import ProcessInfo from './formProcess.vue'
import StatusInfo from './formStatus.vue'

export default {
  props: ['form'],
  components: {
    BasicInfo,
    ProcessInfo,
    StatusInfo
  },
  data () {
    return {
      tab: 'tab-basic-info',
      items: [
        { key: 'basic-info', label: 'รายละเอียดคำร้อง' },
        { key: 'process-info', label: 'ผลการพิจารณา' },
        { key: 'status-info', label: 'สถานะการดำเนินการ' }
      ]
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/management/student/show.vue